import React from "react";
import arrow from "../assets/images/head2.png";
import img1 from "../assets/images/background-about.jpg";
import img2 from "../assets/images/bigdrum-customers.jpg";

const About = () => {
  return (
    <div className="main-div">
      <img src={img1} className="main-img" />
      <div className="div-wrapper">
        <div className="div-wrapper-inner">
          <img src={arrow} className="arrow_img mt ml" />
          <p className="mt">
            <b>Big Drum India</b> is a privately held limited company
            incorporated in the year 2006. The company has been steadily growing
            ever since, providing consistent products without compromising on
            quality with The back bone of our company’s philosophy is quality,
            service, pricing and in time delivery. We have our presence in three
            strategic locations across India - Hyderabad, Ahmadabad and
            Bangalore, to cater to the needs of ice cream suppliers spread
            across India and parts of Asia.
          </p>
          <img src={img2} className="other-img margin" />
        </div>
      </div>
    </div>
  );
};

export default About;
